import { Route as PublicRoute } from 'react-router-dom';

import { PATH_NAME } from '../pathNames';
import { AgeDistribution } from '../lazyLoaded';

const AgeDistributionRoute = () => (
  <PublicRoute
    exact
    path={PATH_NAME.AGE_DISTRIBUTION}
    component={(props: JSX.IntrinsicAttributes) => (
      <AgeDistribution {...props} />
    )}
  />
);
export default AgeDistributionRoute;
